import { connect } from 'react-redux';

import { fetchNotifications } from '../actions/notification';
import NotificationPage from '../components/notification-list/NotificationTable';

const mapState = state => ({
  accessToken: state.user.accessToken,
  isFetching: state.notification.isFetching,
  data: state.notification.data,
  total: state.notification.total,
  page: state.notification.page,
  pageSize: state.notification.pageSize,
  sort: state.notification.sort,
  filter: state.notification.filter
});

const mapDispatch = {
  fetchNotifications
};

export default connect(
  mapState,
  mapDispatch
)(NotificationPage);
